import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { AIBadge } from '../ai-badge/ai-badge.component';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-ai-info',
  templateUrl: './ai-info.component.html',
  styleUrl: './ai-info.component.scss',
  imports: [AIBadge, Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiInfo {
  readonly title = input.required<string>();
  readonly summary = input.required<string>();

  protected readonly isClosed = signal(false);

  protected close(): void {
    this.isClosed.set(true);
  }
}
